export default __webpack_public_path__ + "static/media/OpenSans-BoldItalic.98201916.woff";